<template>
  <div id="SmsSettings">
    
    <LoadingLayout v-if="loading" :page="true" />

    <Page
      v-else
      :title="$t('Settings')"
      :primaryAction="{
        label: $t('Save'),
        onAction: save
      }"
      :secondaryActions="[{
        label: $t('Notes'),
        onAction: () => eventHub.$emit('showAccountNotes', 'SMSSETTINGS')
      }]"
    >
      <Layout>
        <LayoutSection>
          <Card>
            <CardSection>
              <label>{{'Delivery Window'}}</label>
              <FormLayoutGroup>
                <Select
                  v-model="smsSettings.settings.hoursFrom"
                  :options="hourTimings"
                  :placeholder="$t('From')"
                />
                <Select
                  v-model="smsSettings.settings.hoursTo"
                  :options="hourTimings"
                  :placeholder="$t('To')"
                />
              </FormLayoutGroup>
              <div>{{'To make sure that messages are delivered at a good time for your users you can set up a time window in which to send them. This will override the schedule of the individual messages.'}}</div>
            </CardSection>
          </Card>
          <Card>
            <CardSection>
              <Select
                v-model="smsSettings.settings.days"
                :multiple="true"
                :options="daysOfWeek"
                tags
                :placeholder="$t('Any day')"
                :label="$t('Day of the week')"
                :help-text="'Messages will only be sent on the selected days. This will override the schedule of the individual messages.'"
              />
            </CardSection>
          </Card>
          <Card>
            <CardSection>
              <Select
                v-model="smsSettings.settings.minHoursBetween"
                :options="timeBetweenOptions"
                :label="'Time between messages'"
                :help-text="'Messages to individual users will be sent with a minimum of the selected time between them.'"
                :placeholder="$t('Choose Time')"
              />
            </CardSection>
          </Card>
        </LayoutSection>

      </Layout>
    </Page>

  </div>
</template>

<script>

export default {
  name: 'SmsSettings',
  data() {
    return {
      loading: true,
      smsSettings: null
    }
  },
  mounted() {
    // load settings
    this.loading = true
    this.api.getSmsSettings()
      .then((response) => {
        this.smsSettings = response
        if (!this.smsSettings) {
          this.smsSettings = {
            settings: this.getDefaultSettingValues()
          }
        }
      })
      .catch(this.apiCatch)
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    getDefaultSettingValues() {
      return {
        days: [0, 1, 2, 3, 4, 5, 6],
        hoursFrom: '08:00',
        hoursTo: '20:00',
        minHoursBetween: 0
      }
    },
    save() {
      NProgress.start()
      this.api.updateSmsSettings(this.smsSettings)
        .finally(() => {
          this.$ui.toast({ title: this.$t('Saved') })
        })
        .catch(this.apiCatch)
        .finally(() => {
          NProgress.done()
        })
    }
  },
  computed: {
    hourTimings() {
      return [
        // { value: '00:00', label: this.$t('Midnight') },
        // { value: '01:00', label: '1 AM' },
        // { value: '01:30', label: '1:30 AM' },
        // { value: '02:00', label: '2 AM' },
        // { value: '02:30', label: '2:30 AM' },
        // { value: '03:00', label: '3 AM' },
        // { value: '03:30', label: '3:30 AM' },
        // { value: '04:00', label: '4 AM' },
        // { value: '04:30', label: '4:30 AM' },
        // { value: '05:00', label: '5 AM' },
        // { value: '05:30', label: '5:30 AM' },
        // { value: '06:00', label: '6 AM' },
        // { value: '06:30', label: '6:30 AM' },
        // { value: '07:00', label: '7 AM' },
        // { value: '07:30', label: '7:30 AM' },
        { value: '08:00', label: '8 AM' },
        { value: '08:30', label: '8:30 AM' },
        { value: '09:00', label: '9 AM' },
        { value: '09:30', label: '9:30 AM' },
        { value: '10:00', label: '10 AM' },
        { value: '10:30', label: '10:30 AM' },
        { value: '11:00', label: '11 AM' },
        { value: '11:30', label: '11:30 AM' },
        { value: '12:00', label: this.$t('Midday') },
        { value: '12:30', label: '12:30 PM' },
        { value: '13:00', label: '1 PM' },
        { value: '13:30', label: '1:30 PM' },
        { value: '14:00', label: '2 PM' },
        { value: '14:30', label: '2:30 PM' },
        { value: '15:00', label: '3 PM' },
        { value: '15:30', label: '3:30 PM' },
        { value: '16:00', label: '4 PM' },
        { value: '16:30', label: '4:30 PM' },
        { value: '17:00', label: '5 PM' },
        { value: '17:30', label: '5:30 PM' },
        { value: '18:00', label: '6 PM' },
        { value: '18:30', label: '6:30 PM' },
        { value: '19:00', label: '7 PM' },
        { value: '19:30', label: '7:30 PM' },
        { value: '20:00', label: '8 PM' },
        // { value: '20:30', label: '8:30 PM' },
        // { value: '21:00', label: '9 PM' },
        // { value: '21:30', label: '9:30 PM' },
        // { value: '22:00', label: '10 PM' },
        // { value: '22:30', label: '10:30 PM' },
        // { value: '23:00', label: '11 PM' },
        // { value: '23:30', label: '11:30 PM' },
        // { value: '24:00', label: this.$t('Midnight') },
      ]
    },
    daysOfWeek() {
      return [
        { value: 0, label: this.$t('Sunday') },
        { value: 1, label: this.$t('Monday') },
        { value: 2, label: this.$t('Tuesday') },
        { value: 3, label: this.$t('Wednesday') },
        { value: 4, label: this.$t('Thursday') },
        { value: 5, label: this.$t('Friday') },
        { value: 6, label: this.$t('Saturday') },
      ]
    },
    timeBetweenOptions() {
      return [
        { value: 0, label: this.$t('None') },
        { value: 1, label: this.$t('1 Minute') },
        { value: 3, label: this.$t('numberOfMinutes', { count: '3' }) },
        { value: 5, label: this.$t('numberOfMinutes', { count: '5' }) },
        { value: 10, label: this.$t('numberOfMinutes', { count: '10' }) },
        { value: 15, label: this.$t('numberOfMinutes', { count: '15' }) },
        { value: 30, label: this.$t('numberOfMinutes', { count: '30' }) },
        { value: 60, label: this.$t('1 Hour') },
        { value: 120, label: this.$t('numberOfHours', { count: '2' }) },
        { value: 180, label: this.$t('numberOfHours', { count: '3' }) },
        { value: 360, label: this.$t('numberOfHours', { count: '6' }) },
        { value: 720, label: this.$t('numberOfHours', { count: '12' }) },
        { value: 1440, label: this.$t('numberOfHours', { count: '24' }) },
      ]
    }
  }
};
</script>

<style lang="scss">
#SmsSettings {
  .opt-out-subheading {
    margin-bottom: 10px;
  }
  .opt-out-keywords {
    margin-bottom: 7px;
  }
  .opt-out-heading-message {
    margin-bottom: 0px;
  }
  .opt-out-subheading-message {
    margin-bottom: 10px;
  }
  .reserved-keyword {
    display: inline-block;
    color: #008CFF;
    background-color: #E1F5FE;
    padding: 3px 7px;
    border-radius: 3px;
    margin-left: 10px;
  }
}
</style>
